import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aeb8a882"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base64-converter m-16" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Base64 Converter", -1))
const _hoisted_3 = { class: "buttons" }
const _hoisted_4 = {
  key: 0,
  class: "result-display"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Result:", -1))
const _hoisted_6 = { class: "result" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _withDirectives(_createElementVNode("textarea", {
      class: "w-[80%] h-[100px] p-2.5 mb-4 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50 resize-y",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.base64Text) = $event)),
      placeholder: "Enter text"
    }, null, 512), [
      [_vModelText, _ctx.base64Text]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "action-btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.encodeBase64 && _ctx.encodeBase64(...args)))
      }, "Encode"),
      _createElementVNode("button", {
        class: "action-btn",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.decodeBase64 && _ctx.decodeBase64(...args)))
      }, "Decode")
    ]),
    (_ctx.base64Result)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.base64Result), 1),
          _createElementVNode("button", {
            class: "copy-btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyToClipboard(_ctx.base64Result)))
          }, "Copy Result")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["snackbar", { show: _ctx.showSnackbar }])
    }, "Copied to clipboard!", 2)
  ]))
}